import React from 'react';
import {Row, Col, ProgressBar} from 'react-bootstrap';
require(`../assets/${process.env.PAGE}/css/components/custom-progress-bar.css`);

const CustomProgressBar = ({label, percentage}) => (
<Row>
    <Col xs={12} md={12} lg={12} className={'text-center'}>{label}</Col>  
    <Col xs={12} md={12} lg={12}><ProgressBar now={percentage} label={`${percentage}%`} className={'custom-progress-bar'}/></Col>
</Row>
       
    
  
)

export default CustomProgressBar;


/** WEBPACK FOOTER **
 ** ./src/components/CustomProgressBar.js
 **/